<template>
    <div class="flex h-full w-full contrast-dark-400">
        <transition name="fade">
            <hider key="choose" title="избор" component="counting"></hider>
        </transition>
        <!--   question     -->
        <div v-if="!answered" class="flex h-full w-full p-2 align-middle items-center p-4">
            <div class="w-full" v-if="question">
                <div class="text-center text-2xl mb-4">
                    {{question.name}}
                    <hr class="border-dark-100 mt-1">
                </div>
                <div class="max-w-sm m-auto">
                    <div @click="set_answer(answer.correct)" v-for="(answer,index) in question.answers" class="border border-dark-100 rounded p-2 mb-2 hover:bg-dark">
                        {{answer.name}}
                    </div>
                </div>
            </div>
            <div v-else class="w-full text-danger text-center" >
                Не е открит въпрос по избраната тема
            </div>
        </div>
        <!--   answered     -->
        <div class="flex items-center text-center w-full" v-else>
            <transition name="fade">
                <hider key="check" title="Проверка" :delay="3200" component="counting" class="z-50"></hider>
            </transition>
            <div v-if="answered==='correct'" class="m-auto">
                <p class="text-2xl text-success-100">Верен отговор!</p>
                <div class="emoji  emoji--yay">
                    <div class="emoji__face">
                        <div class="emoji__eyebrows"></div>
                        <div class="emoji__mouth"></div>
                    </div>
                </div>
                <div v-if="gift" class="max-w-sm">
                    <p>Подарък:</p>
                    <div class="text-2xl p-4 border border-success-100 m-2 rounded-lg text-white font-bold">{{gift.name}}</div>
                    <div class="my-4">
                        <input class="underlined_input" type="text" v-model="full_name" placeholder="Трите имена">
                        <input class="underlined_input" type="text" v-model="pharmacy" placeholder="Аптека">
                        <input class="underlined_input" type="text" v-model="city" placeholder="Населено място">
                    </div>
                    <div>
                        <button v-if="!sending" class="btn btn-success mr-2" @click="send">Потвърди</button>
                        <button v-if="!sending" class="btn btn-danger" @click="$router.push('/')">Откажи</button>
                        <div v-else>Изпращане...</div>
                    </div>
                </div>
                <div v-else class="max-w-sm">
                    Не е открит наличен подарък!
                </div>
            </div>
            <div v-else class="m-auto">
                <div class="emoji  emoji--sad">
                    <div class="emoji__face">
                        <div class="emoji__eyebrows"></div>
                        <div class="emoji__eyes"></div>
                        <div class="emoji__mouth"></div>
                    </div>
                </div>
                <div>
                    Грешен отговор!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import ApiService from "../services/api.service"

    export default {
        name: 'ask',
        data() {
            return {
                answered:null,
                gift:null,
                full_name:null,
                pharmacy:null,
                city:null,
                sending:false
            }
        },
        computed: {
            ...mapGetters('profile', ['logged_user']),
            question() {
                let quiz = this.logged_user.quizzes.find(
                    quiz => Number(quiz.id) === Number(this.$route.params.quiz_id)
                );

                let theme = quiz.themes.find(
                    theme => Number(theme.id) === Number(this.$route.params.theme_id)
                );
                if (theme.questions.length) {
                    //console.log('length: ' + theme.questions.length);
                    let random = theme.questions.length > 1 ? this.randomInt(0,theme.questions.length-1) : 0;
                    //console.log(random);
                    return theme.questions[random];
                }

                return null;
            },
            isValid(){
                return !!(this.full_name && this.city && this.pharmacy);
            }
        },
        methods: {
            ...mapMutations('snack_bar', ['snack_bar_fire']),
            ...mapMutations('profile', ['decrement_gift']),
            randomInt(min, max) {
               //console.log(min,max);
                return Math.floor(Math.random() * (max - min + 1)) + min;
            },
            set_answer(correct){
                 if(correct === '1'){
                     this.set_gift();
                     this.answered = 'correct';
                 }else{
                     this.answered = 'mistake';
                 }

            },
            set_gift(){
                let gifts = this.logged_user.gifts.filter(
                    gift =>
                        Number(gift.quiz_id) === Number(this.$route.params.quiz_id)
                        &&
                        gift.availability>0
                )

                if (gifts.length) {
                    let random = gifts.length > 1 ? this.randomInt(0,gifts.length-1) : 0;
                    this.gift=gifts[random];
                }
            },
            async send(){
                if(this.isValid){
                    this.sending=true;
                    let self_rate_request = {
                        method: 'post',
                        url: "/api/quiz/make_gift",
                        data: {
                            name:this.full_name,
                            pharmacy: this.pharmacy,
                            city:this.city,
                            gift_id:this.gift.id,
                            quantity:-1,
                            user_id: this.logged_user.id,
                            is_from_api:1
                        }
                    }

                    try {
                        const response = await ApiService.customRequest(self_rate_request)
                        await this.decrement_gift(this.gift.id);
                        await this.snack_bar_fire({message:'Подаръка е отчетен',type: 'success'});
                        await this.$router.push('/');
                    }

                    catch (e) {
                        return false
                    }

                }else{
                    this.snack_bar_fire({message:'Моля, попълнете всички полета',type: 'error'});
                }
            }
        },
        mounted() {

        }
    }
</script>
